module.exports = __webpack_public_path__ + "static/Retirees-6d59dc08d2d30b97ce07fd17f468f02c.jpg";